module.exports = __webpack_public_path__ + "static/media/md-flower.e226ba32.svg";